import {
    ChangeDetectionStrategy,
    Component,
    effect,
    Injector,
    inject,
    input,
    numberAttribute,
    output,
    untracked,
} from '@angular/core';
import { areResumeStatesEqual, RESUME_INITIAL_STATE } from './cost-to-build-client-ui-resume.state';
import { ResumeStore } from './cost-to-build-client-ui-resume.store';
import type { ResumeState } from './cost-to-build-client-ui-resume.types';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    providers: [ResumeStore],
    selector: 'ctb-resume',
    styleUrl: './cost-to-build-client-ui-resume.scss',
    templateUrl: './cost-to-build-client-ui-resume.html',
})
export class CtbResumeComponent {
    readonly #injector = inject(Injector);
    readonly #store = inject(ResumeStore);

    readonly description = input<string>(RESUME_INITIAL_STATE.description);
    readonly maxPrice = input(RESUME_INITIAL_STATE.maxPrice, { transform: numberAttribute });
    readonly minPrice = input(RESUME_INITIAL_STATE.minPrice, { transform: numberAttribute });

    readonly stateChange = output<ResumeState>();

    readonly formattedPriceRange = this.#store.formattedPriceRange;
    readonly state = this.#store.state;

    #lastEmittedState: ResumeState | null = null;

    readonly syncStoreFromInputs = effect(() => this.#syncStoreFromInputs(), { injector: this.#injector });

    readonly emitStateChanges = effect(
        () => {
            const nextState = this.state();
            const previousState = this.#lastEmittedState;

            if (previousState !== null && areResumeStatesEqual(previousState, nextState)) {
                return;
            }

            this.#lastEmittedState = nextState;
            this.stateChange.emit(nextState);
        },
        { injector: this.#injector }
    );

    #syncStoreFromInputs() {
        const patch = {
            description: this.description(),
            maxPrice: this.maxPrice(),
            minPrice: this.minPrice(),
        };

        untracked(() => this.#store.setState(patch));
    }
}
